<template>
  <div class="xin">
    <div class="zhuye">
      <!--  柱状图 -->
      <div class="b ">
        <div class="sele">
          <span style="padding-right:40px">{{ $t("logs.zhu_info1") }}</span>
          <div>
            <el-select
              v-model="salt_minion_ip"
              placeholder="请选择"
              class="sele1"
              @change="change1"
              v-if="this.has_minion1 == 1"
            >
              <el-option
                v-for="item in minion_host"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="stat_type"
              placeholder="请选择"
              class="sele2"
              @change="change2"
            >
              <el-option
                v-for="item in stattype"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div
          id="zhutu"
          style="width:45vw;height:39vh"
          v-loading="loading1"
        ></div>
      </div>
      <div class="b b1">
        <div class="sele">
          <span style="width:108px">{{ $t("logs.zhu_info2") }}</span>
          <div>
            <el-select
              v-model="stat_type2"
              placeholder="请选择"
              class="sele2"
              @change="change4"
            >
              <el-option
                v-for="item in stattype_arr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div
          id="zhuangtai"
          style="width:32vw;height:39vh"
          v-loading="loading2"
        ></div>
      </div>
    </div>
    <div class="zhuye">
      <!--  垃圾分类图 -->
      <div class="b">
        <div class="sele">
          <span style="padding-right:40px">{{ $t("logs.zhu_info3") }} </span>

          <el-select
            v-model="stat_type3"
            placeholder="请选择"
            class="sele2"
            @change="change5"
          >
            <el-option
              v-for="item in stattype3"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div
          id="junk"
          style="width:45vw;height:39vh"
          v-loading="loading3"
        ></div>
      </div>
      <!--  饼状CPU类图 -->
      <div class="b b1">
        <div class="sele">
          <span style="padding-right:40px">{{ $t("logs.zhu_info4") }}</span>
          <el-select
            v-model="salt_minion_ip4"
            placeholder="请选择"
            class="sele1"
            @change="change6"
            v-if="this.has_minion3 == 1"
          >
            <el-option
              v-for="item in minion_host4"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div id="cpu" style="width:20vw;height:39vh" v-loading="loading4"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "echarts/lib/component/toolbox";
var myChart1;
var myChart2;
var myChart3;
var myChart4;
export default {
  data() {
    return {
      // 邮件统计
      stat_type: "按天统计",
      stat_type1: [],
      mstat_type1: [],
      stattype: "",
      salt_minion_ip: "127.0.0.1",
      salt_minion_ip1: [],
      msalt_minion_ip1: "",
      minion_host: [],
      minion_host4: [],
      // 垃圾隔离
      stat_type3: 0,
      stattype3: [],
      advnum: "", //广告
      fishnum: "", //钓鱼
      polnum: "", //反动
      sexnum: "", //色情
      totalnum: "", //总数
      virusnum: "", //病毒othernum
      othernum: "", //其他
      // cpu
      stat_type4: "127.0.0.1",
      stattype4: [],
      isA: false,
      data1: [],
      cpu_used: "",
      stat_type2: "",
      stattype_arr: [],
      dataEmpty: false,
      // 柱状图
      time: "",
      // 拦截数
      rejects: "",
      //收发
      time_rec: [],
      send_msg: [],
      rcv_msg: [],
      messages: "",
      //连接数
      connects: [],
      langea: "",
      has_minion1: "",
      has_minion2: "",
      has_minion3: "",
      salt_minion_ip4: "",
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
    };
  },
  created() {},
  mounted() {
    // 存值
    // if (JSON.parse(sessionStorage.getItem("val")) == null) {
    //   this.$i18n.locale = JSON.parse(sessionStorage.getItem("usermsg")).lang;
    //   console.log(this.$i18n.locale);

    //   let redirect_index = JSON.parse(sessionStorage.getItem("usermsg"))
    //     .redirect;
    //   console.log(redirect_index);
    //  this.$root.jurisdiction.only_query=JSON.parse(sessionStorage.getItem("usermsg")).fm_not_readonly;
    //   console.log(this.$root.jurisdiction.only_query)
    //   this.$router.push({
    //     path: redirect_index,
    //   });

    //   sessionStorage.setItem("val", "1");

    //   //    window.location.reload();
    // }

    // let language = JSON.parse(sessionStorage.getItem("val"));
    // console.log(language, '存入的值')

    this.getFileList4();

    this.getFileList1();
    this.getFileList2();
    this.getFileList3();
  },
  methods: {
    // lang() {
    //     this.langea = 0
    //     if (this.langea == '1') {
    //         //
    //         console.log(this.langea)
    //         this.langea = 0

    //     } else if (this.langea == 0) {
    //         this.langea = 1

    //         window.location.reload()
    //         console.log(this.langea, '444')

    //     }
    // },
    // 下拉框点击选中
    change1(a) {
      // console.log(a);
      this.salt_minion_ip1 = a;
      this.getFileList1();
    },

    change4(a) {
      // console.log(a);
      this.stat_type2 = a;
      this.getFileList2();
    },
    // 下拉框点击选中
    change2(a) {
      console.log(a);
      this.stat_type1 = a;
      this.getFileList1();
    },
    change5(a) {
      // console.log(a);
      this.stat_type3 = a;
      this.getFileList3();
    },
    change6(a) {
      // console.log(a);
      this.salt_minion_ip4 = a;
      this.getFileList4();
    },
    // 数据

    getFileList3() {
      this.loading3 = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      let stat_type = this.stat_type3;
      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "show_spam_type_report",
            sid: sid,
            stat_type: stat_type,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          // console.log(col, "传的col值");

          // console.log(this.col1, "传的col1值");
          // console.log(this.page, '222')

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            // this.fileList = res.data.ret.datalist;
            if (res.data.ret.HAS_MINION) {
              this.has_minion2 = 1;
            }
            this.advnum = res.data.ret.advnum;
            this.fishnum = res.data.ret.fishnum;
            this.polnum = res.data.ret.polnum;
            this.sexnum = res.data.ret.sexnum;
            this.virusnum = res.data.ret.virusnum;
            this.othernum = res.data.ret.othernum;
            this.totalnum = res.data.ret.totalnum;

            // console.log(this.messages);

            this.connects = res.data.ret.connects;
            // console.log(this.connects);

            this.stat_type3 = res.data.ret.cur_type;

            this.stattype3 = res.data.ret.q_type;
            // for (let i = 0; i < this.fileList.length; ++i) {
            //     this.fileList[i].SHOW_MORE = '展示更多'
            // }

            this.junk();
          }
        });
    },
    // 数据

    getFileList4() {
      this.loading4 = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      let salt_minion_ip = this.salt_minion_ip4;

      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "show_cpuinfo",
            sid: sid,
            salt_minion_ip: salt_minion_ip,
          },
        })
        .then((res) => {
          console.log(res);
          // console.log(col, "传的col值");

          // console.log(this.col1, "传的col1值");
          // console.log(this.page, '222')

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            // this.fileList = res.data.ret.datalist;
            if (res.data.ret.HAS_MINION) {
              this.has_minion3 = 1;
            }
            this.cpu_used = res.data.ret.datalist[0].CPU_USED;
            // console.log(this.cpu_used)
            // this.stat_type4 = res.data.ret.q_minion_host[0].label;
            this.salt_minion_ip4 = res.data.ret.salt_minion_ip;
            this.minion_host4 = res.data.ret.q_minion_host;
            // for (let i = 0; i < this.fileList.length; ++i) {
            //     this.fileList[i].SHOW_MORE = '展示更多'
            // }

            this.cpu();
          }
        });
    },
    // 柱状图

    zhutu1() {
      // 基于准备好的dom，初始化echarts实例
      // 如果想要修改默认配置参数，可以通过如下方式
      if (myChart1 != null && myChart1 != "" && myChart1 != undefined) {
        //  console.log('come-----',myChart1,'.....')
        myChart1.dispose(); //解决echarts dom已经加载的报错
      }

      myChart1 = this.$echarts.init(document.getElementById("zhutu"));
      // 绘制图表

      myChart1.showLoading({
        text: "loading",
        color: "#c23531",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0,
      });
      setTimeout(() => {
        // setOption前隐藏loading事件
        myChart1.hideLoading();
        myChart1.setOption(option);
        this.loading1 = false;
      }, 1000);

      const option = {
        backgroundColor: "#fff",
        //        title:{
        //           text:'邮件统计图',
        //           textStyle: {
        //             // 图列内容样式

        //             fontfamily: "PingFangSC-Medium, PingFang SC",

        //             color: "#0e2c5e", // 字体颜色
        // // fontStyle:'normal',
        //             fontWeight: 600,
        //             fontSize:16,

        //             backgroundColor: "#fff", // 字体背景色
        //           },
        //        },
        color: [" #1F87FF", "#ff761b", "#00e9da"],
        tooltip: {},
        legend: {
          type: "plain",
          top: "1%", // 图列相对容器的位置 top\bottom\left\right
          right: "0",
          // textStyle: {
          //   // 图列内容样式

          //   fontfamily: "PingFangSC-RegularPingFang SC",

          //   color: "#818EA8", // 字体颜色

          //   fontweight: "400",

          //   backgroundColor: "#fff", // 字体背景色
          // },
        },

        xAxis: {
          splitLine: {
            // gird区域中的分割线
            show: false, // 是否显示
            lineStyle: {
              color: "red",
              width: 1,
              type: "solid",
            },
          },
          splitArea: {
            // 网格区域
            show: false, // 是否显示，默认为false
          },
          axisLine: {
            // 坐标轴 轴线
            show: true, // 是否显示
            // symbol: ['none', 'arrow'], // 是否显示轴线箭头
            symbolSize: [8, 8], // 箭头大小
            symbolOffset: [0, 7], // 箭头位置
            // ------   线 ---------
            lineStyle: {
              color: "#818ea8",
              width: 1,
              type: "solid",
            },
          },
          axisTick: {
            // 坐标轴 刻度
            show: true, // 是否显示
            inside: true, // 是否朝内
            length: 5, // 长度
            lineStyle: {
              // 默认取轴线的样式
              color: "#818ea8",
              width: 1,
              type: "solid",
            },
          },
          data: this.time,
          axisLabel: {
            // 坐标轴标签
            show: true, // 是否显示
            inside: false, // 是否朝内
            rotate: 0, // 旋转角度
            margin: 5, // 刻度标签与轴线之间的距离

            color: "#0E2C5E", // 默认取轴线的颜色
            backgroundColor: "#fff", // 字体背景色
            fontfamily: "PingFangSC-Medium, PingFang SC",

            // fontStyle:'normal',
            fontWeight: 400,
            fontSize: 12,
          },
        },
        // itemStyle: { // 图形的形状
        //     color: 'blue',
        //     barBorderRadius: [18, 18, 0, 0]
        // },
        barGap: "50%", // 柱间距离，默认为柱形宽度的30%，可设固定值
        // barCategoryGap: '20%', // 类目间柱形距离，默认为类目间距的20%，可设固定值
        barWidth: 8, // 柱形的宽度

        // 位置

        grid: {
          top: "14%",

          bottom: "14%",
        },

        yAxis: [
          {
            type: "value", // 轴类型，

            axisTick: {
              // 坐标轴 刻度
              show: false, // 是否显示
              inside: true, // 是否朝内
              length: 5, // 长度
              lineStyle: {
                // 默认取轴线的样式
                color: "#818ea8",
                width: 1,
                type: "solid",
              },
            },

            scale: true,
            axisLine: {
              // 坐标轴 轴线
              show: true, // 是否显示
              // symbol: ['none', 'arrow'], // 是否显示轴线箭头
              symbolSize: [8, 8], // 箭头大小
              symbolOffset: [0, 7], // 箭头位置
              // ------   线 ---------
              lineStyle: {
                color: "#818ea8",
                width: 1,
                type: "solid",
              },
            },
            axisLabel: {
              // 坐标轴的标签
              show: true, // 是否显示
              inside: false, // 是否朝内
              rotate: 0, // 旋转角度
              margin: 5, // 刻度标签与轴线之间的距离
              backgroundColor: "#fff", // 字体背景色
              color: "#0E2C5E", // 默认取轴线的颜色

              formatter: function(value) {
                if (value <= 1000) {
                  // value=value;
                  return value;
                } else {
                  value = value / 1000 + "k";

                  return value;
                }

                // if (value >= 100 && value < 1000) {
                //     value = value / 100 + "k";
                // } else if (value >= 10000) {
                //     value = value / 1000 + "k";
                // }
                // return value;
              },
            },
            splitLine: {
              // gird 区域中的分割线
              show: true, // 是否显示
              lineStyle: {
                color: "#D2D7E6",
                width: 1,
                type: "solid",
              },
            },
          },
        ],

        series: [
          {
            name: `${this.$t("logs.zhu_info1_1")}`,

            type: "bar",
            data: this.messages,
          },
          {
            name: `${this.$t("logs.zhu_info1_2")}`,
            type: "bar",
            data: this.rejects,
          },
          {
            name: `${this.$t("logs.zhu_info1_3")}`,
            type: "bar",
            data: this.connects,
          },
        ],
      };
      window.addEventListener("resize", function() {
        myChart1.resize();
      });
      // window.onresize = () => {
      //   // this.$echarts.init(document.getElementById('zhutu')).resize();
      //   myChart1.resize();
      // }
    },
    // 收发图
    initZtData() {
      // 基于准备好的dom，初始化echarts实例
      if (myChart2 != null && myChart2 != "" && myChart2 != undefined) {
        //  console.log('come-----',myChart2,'.....')
        myChart2.dispose(); //解决echarts dom已经加载的报错
      }
      myChart2 = this.$echarts.init(document.getElementById("zhuangtai"));
      // 绘制图表

      myChart2.showLoading({
        text: "loading",
        color: "#c23531",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0,
      });
      setTimeout(() => {
        // setOption前隐藏loading事件
        myChart2.hideLoading();
        myChart2.setOption(option);
        this.loading2 = false;
      }, 1000);
      const option = {
        backgroundColor: "#fff",

        color: ["#FF761B", "#006BE7", "#ffdb5c"],
        // symbol:'circle',
        // symbolSize: 9, // 设定折线点的大小
        // 折线条的样式
        // lineStyle: {
        // color: '#3aa7ff',
        // width: 4
        // },
        title: {
          text: "", //主标题
          x: "left", //x轴方向对齐方式
        },

        tooltip: {},

        legend: {
          type: "plain",

          top: "1%", // 图列相对容器的位置 top\bottom\left\right
          right: "0",
          // textStyle: {
          //   // 图列内容样式

          //   fontfamily: "PingFangSC-RegularPingFang SC",

          //   color: "#818EA8", // 字体颜色

          //   fontweight: "400",

          //   backgroundColor: "#fff", // 字体背景色
          // },
        },
        xAxis: {
          splitLine: {
            // gird区域中的分割线
            show: false, // 是否显示
            lineStyle: {
              color: "red",
              width: 1,
              type: "solid",
            },
          },
          splitArea: {
            // 网格区域
            show: false, // 是否显示，默认为false
          },
          axisLine: {
            // 坐标轴 轴线
            show: true, // 是否显示
            // symbol: ['none', 'arrow'], // 是否显示轴线箭头
            symbolSize: [8, 8], // 箭头大小
            symbolOffset: [0, 7], // 箭头位置
            // ------   线 ---------
            lineStyle: {
              color: "#818ea8",
              width: 1,
              type: "solid",
            },
          },
          axisTick: {
            // 坐标轴 刻度
            show: true, // 是否显示
            inside: true, // 是否朝内
            length: 5, // 长度
            lineStyle: {
              // 默认取轴线的样式
              color: "#818ea8",
              width: 1,
              type: "solid",
            },
          },
          data: this.time_rec,
          axisLabel: {
            // 坐标轴标签
            show: true, // 是否显示
            inside: false, // 是否朝内
            rotate: 0, // 旋转角度
            margin: 5, // 刻度标签与轴线之间的距离
            backgroundColor: "#fff", // 字体背景色
            color: "#0E2C5E", // 默认取轴线的颜色
          },
        },
        // itemStyle: { // 图形的形状
        //     color: 'blue',
        //     barBorderRadius: [18, 18, 0, 0]
        // },
        barGap: "50%", // 柱间距离，默认为柱形宽度的30%，可设固定值
        // barCategoryGap: '20%', // 类目间柱形距离，默认为类目间距的20%，可设固定值
        barWidth: 8, // 柱形的宽度

        // 位置

        grid: {
          top: "14%",

          bottom: "14%",
        },

        yAxis: [
          {
            type: "value", // 轴类型，

            axisTick: {
              // 坐标轴 刻度
              show: false, // 是否显示
              inside: true, // 是否朝内
              length: 5, // 长度
              lineStyle: {
                // 默认取轴线的样式
                color: "#818ea8",
                width: 1,
                type: "solid",
              },
            },

            scale: true,
            axisLine: {
              // 坐标轴 轴线
              show: true, // 是否显示
              // symbol: ['none', 'arrow'], // 是否显示轴线箭头
              symbolSize: [8, 8], // 箭头大小
              symbolOffset: [0, 7], // 箭头位置
              // ------   线 ---------
              lineStyle: {
                color: "#818ea8",
                width: 1,
                type: "solid",
              },
            },
            axisLabel: {
              // 坐标轴的标签
              show: true, // 是否显示
              inside: false, // 是否朝内
              rotate: 0, // 旋转角度
              margin: 5, // 刻度标签与轴线之间的距离
              backgroundColor: "#fff", // 字体背景色
              color: "#0E2C5E", // 默认取轴线的颜色
              formatter: function(value) {
                if (value <= 1000) {
                  // value=value;
                  return value;
                } else {
                  value = value / 1000 + "k";

                  return value;
                }
              },
            },
            splitLine: {
              // gird 区域中的分割线
              show: true, // 是否显示
              lineStyle: {
                color: "#D2D7E6",
                width: 1,
                type: "solid",
              },
            },
          },
        ],

        series: [
          {
            name: `${this.$t("logs.zhu_info2_1")}`,
            type: "line",
            symbol: "circle", //折线点设置为实心点
            symbolSize: 8, //折线点的大小

            data: this.rcv_msg,
          },
          {
            name: `${this.$t("logs.zhu_info2_2")}`,
            type: "line",
            symbol: "circle", //折线点设置为实心点
            symbolSize: 8, //折线点的大小
            data: this.send_msg,
          },
        ],
      };
      window.addEventListener("resize", function() {
        myChart2.resize();
      });
    },
    // 垃圾分类图
    junk() {
      // 基于准备好的dom，初始化echarts实例
      if (myChart3 != null && myChart3 != "" && myChart3 != undefined) {
        //  console.log('come-----',myChart3,'.....')
        myChart3.dispose(); //解决echarts dom已经加载的报错
      }
      myChart3 = this.$echarts.init(document.getElementById("junk"));
      // 绘制图表
      myChart3.showLoading({
        text: "loading",
        color: "#c23531",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0,
      });
      setTimeout(() => {
        // setOption前隐藏loading事件
        myChart3.hideLoading();
        myChart3.setOption(option);
        this.loading3 = false;
      }, 1000);
      const option = {
        // 病毒  钓鱼 色情 其他 广告 政治
        backgroundColor: "#fff",

        color: [
          "#ff5454",
          "#00C5B7",
          "#FF761A",
          "#1F87FF",
          "#FF1F75",
          "#5348C0",
        ],
        title: {
          text: "", //主标题
          subtext: `${this.$t("logs.zhu_info3_7")} ${this.totalnum}`,
          x: "left", //x轴方向对齐方式
          subtextStyle: {
            //图例文字的样式
            color: "#333", //文字颜色
            fontSize: 12, //文字大小
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          //图例
          orient: "vertical", //图例的布局，竖直    horizontal为水平
          x: "right", //图例显示在右边
          y: "10px",
          data: [
            `${this.$t("logs.zhu_info3_1")}`,
            `${this.$t("logs.zhu_info3_2")}`,
            `${this.$t("logs.zhu_info3_3")}`,
            `${this.$t("logs.zhu_info3_4")}`,
            `${this.$t("logs.zhu_info3_5")}`,
            `${this.$t("logs.zhu_info3_6")}`,
          ],
          // textStyle: {
          //   //图例文字的样式
          //   color: "#333", //文字颜色
          //   fontSize: 12, //文字大小
          // },
        },
        series: [
          {
            type: "pie",
            // selectedMode: 'single',
            radius: ["45%", "70%"],
            center: ["50%", "50%"],
            // label: {
            //     position: 'inner'
            // },
            selectedMode: "single",
            labelLine: {
              show: true,
            },
            data: [
              {
                value: this.virusnum,
                name: `${this.$t("logs.zhu_info3_1")}`,
              },
              {
                value: this.fishnum,
                name: `${this.$t("logs.zhu_info3_2")}`,
              },
              {
                value: this.sexnum,
                name: `${this.$t("logs.zhu_info3_3")}`,
              },
              {
                value: this.othernum,
                name: `${this.$t("logs.zhu_info3_4")}`,
              },
              {
                value: this.advnum,
                name: `${this.$t("logs.zhu_info3_5")}`,
              },
              {
                value: this.polnum,
                name: `${this.$t("logs.zhu_info3_6")}`,
              },
            ],
          },
        ],
      };
      window.addEventListener("resize", function() {
        myChart3.resize();
      });
    },
    // cpu分类图
    cpu() {
      // 基于准备好的dom，初始化echarts实例
      if (myChart4 != null && myChart4 != "" && myChart4 != undefined) {
        //  console.log('come-----',myChart4,'.....')
        myChart4.dispose(); //解决echarts dom已经加载的报错
      }
      myChart4 = this.$echarts.init(document.getElementById("cpu"));
      // 绘制图表
      myChart4.showLoading({
        text: "loading",
        color: "#c23531",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0,
      });
      setTimeout(() => {
        // setOption前隐藏loading事件
        myChart4.hideLoading();
        myChart4.setOption(option);
        this.loading4 = false;
      }, 1000);
      const option = {
        backgroundColor: "#fff",

        // color: ["#91c7ae", "#d48265", "rgb(235, 64, 169)", "#61a0a8", "#c23531"],
        title: {
          text: "", //主标题
          x: "left", //x轴方向对齐方式
        },
        // detail: {
        //     textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        //         // fontWeight: 'bolder',
        //         fontSize: '14px',
        //     }
        // },
        tooltip: {
          formatter: "{a} <br/>{b} : {c}%",
        },
        toolbox: {
          show: true,
          feature: {
            mark: {
              show: true,
            },
            restore: {
              show: false,
            },
            saveAsImage: {
              show: false,
            },
          },
        },

        // toolbox: {
        //     feature: {
        //         restore: {},
        //         saveAsImage: {}
        //     }
        // },
        // series: [{
        //     name: 'CPU',
        //     type: 'gauge',
        //     radius: "65%",
        //     center: ["50%", "50%"],
        //     axisLine: { // 坐标轴线
        //         lineStyle: { // 属性lineStyle控制线条样式
        //             width: 6
        //         }
        //     },
        //     axisTick: { // 坐标轴小标记
        //         length: 10, // 属性length控制线长
        //         lineStyle: { // 属性lineStyle控制线条样式
        //             color: 'auto'
        //         }
        //     },
        //     splitLine: { // 分隔线
        //         length: 10, // 属性length控制线长
        //         lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
        //             color: 'auto'
        //         }
        //     },

        //     detail: {
        //         formatter: '{value}%'
        //     },
        //     data: [{
        //         value: this.cpu_used,
        //         // name: '指标'
        //     }]
        // }],
        series: [
          {
            name: "占有率",
            type: "gauge",
            splitNumber: 10, // 分割段数，默认为5
            radius: "75%",
            center: ["50%", "50%"],
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [0.2, "#1F87FF"],
                  [0.8, "#818EA8"],
                  [1, "#FF5454"],
                ],
                width: 7,
              },
            },
            axisTick: {
              // 坐标轴小标记
              splitNumber: 10, // 每份split细分多少段
              length: 3, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto",
              },
            },
            axisLabel: {
              // 坐标轴文本标签，详见axis.axisLabel
              backgroundColor: "#fff", // 字体背景色
            },
            splitLine: {
              // 分隔线
              show: true, // 默认显示，属性show控制显示与否
              length: 12, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                // color: 'left'
              },
            },
            pointer: {
              //指针
              width: 4,
            },
            title: {
              show: true,
              offsetCenter: [0, "-40%"], // x, y，单位px
              textStyle: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: "bolder",
              },
            },
            detail: {
              formatter: "{value}%",
              textStyle: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                color: "auto",
                fontWeight: "bolder",
                fontSize: "18",
              },
            },
            // data:[{value: 50, name: '完成率'}]
            data: [
              {
                value: this.cpu_used,
                // name: '指标'
              },
            ],
          },
        ],
      };
      window.addEventListener("resize", function() {
        myChart4.resize();
      });
      //  window.onresize = () => {
      //   // this.$echarts.init(document.getElementById('zhutu')).resize();
      //   myChart4.resize();
      // }
    },
    //         clearInterval(timeTicket),
    // timeTicket = setInterval(function (){
    //     option.series[0].data[0].value = (Math.random()*100).toFixed(2) - 0;
    //     myChart.setOption(option,true);
    // },2000),
    toggle: function() {
      this.isA = !this.isA;
    },
    // 数据

    getFileList1() {
      this.loading1 = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let salt_minion_ip =
        this.salt_minion_ip1 == ""
          ? this.msalt_minion_ip1
          : this.salt_minion_ip1;
      let stat_type =
        this.stat_type1 == "" ? this.mstat_type1 : this.stat_type1;
      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "show_home",
            sid: sid,
            salt_minion_ip: salt_minion_ip,
            stat_type: stat_type,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          // console.log(col, "传的col值");

          // console.log(this.col1, "传的col1值");
          // console.log(this.page, '222')

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            if (res.data.ret.HAS_MINION) {
              this.has_minion1 = 1;
            }
            // this.fileList = res.data.ret.datalist;
            this.time = res.data.ret.time;
            this.rejects = res.data.ret.rejects;
            this.messages = res.data.ret.messages;
            // console.log(this.messages);

            this.connects = res.data.ret.connects;
            // console.log(this.connects);
            // this.salt_minion_ip = res.data.ret.q_minion_host[0].label;
            this.msalt_minion_ip1 = res.data.ret.cur_minion_host;
            // this.stat_type = res.data.ret.q_type[0].label;
            this.mstat_type1 = res.data.ret.cur_type;
            this.minion_host = res.data.ret.q_minion_host;
            this.stattype = res.data.ret.q_type;
            // for (let i = 0; i < this.fileList.length; ++i) {
            //     this.fileList[i].SHOW_MORE = '展示更多'
            // }
            this.zhutu1();
          }
        });
    },
    getFileList2() {
      this.loading2 = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      let stat_type = this.stat_type2;
      this.$axios
        .get("/api/adm/cgi/mon.cgi", {
          params: {
            __mode: "show_send_rcv_msgs",
            sid: sid,
            stat_type: stat_type,
            // screen: "real_filterlog.html",
          },
        })
        .then((res) => {
          console.log(res);
          // console.log(col, "传的col值");

          // console.log(this.col1, "传的col1值");
          // console.log(this.page, '222')

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            // alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            if (res.data.ret.HAS_MINION) {
              this.has_minion1 = 1;
            }
            // this.fileList = res.data.ret.datalist;
            this.time_rec = res.data.ret.time;
            this.send_msg = res.data.ret.send_msgs;
            this.rcv_msg = res.data.ret.rcv_msgs;

            // console.log(this.messages);

            this.stat_type2 = res.data.ret.cur_type;

            this.stattype_arr = res.data.ret.q_type;

            this.initZtData();
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.zhuye {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  // border-bottom: 5px solid #ededed;
}

.b {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 56%;
  // height: calc(45vh);
  // height: 300px;

  background: #fff;
  border: 1px solid #d2d7e6;
  margin: 10px 5px 5px 10px;
  // border-right: 5px solid #ededed;
}

.zhuye .b1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
  // height: calc(45vh);
  // height: 300px;

  border: 1px solid #d2d7e6;
  margin: 10px 10px 5px 8px;
}

// /deep/.ve-histogram {
//     height: 230px;

//     // display: flex;
//     // align-items: center;
//     // justify-content: center;

// }

// /deep/.ve-histogram canvas {
//     top: 14px
// }

.sele {
  width: 96%;
  display: flex;
  justify-content: space-between;
  // padding: 0 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.sele span {
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #0e2c5e;
}

// 下拉框
// ::v-deep {
//     .el-input__inner {
//         &::placeholder {
//             color: red;
//         }
//     }
// }
.sele1 {
  margin-right: 10px;

  /deep/ .el-input__inner {
    width: 190px;
    height: 24px;
    line-height: 24px;

    border: 1px solid #d2d7e6;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 14px;
    color: #818ea8;

    // color: #f0f;
  }

  /deep/ .el-input--suffix {
    width: 190px;
    height: 24px;
  }

  /deep/ .el-select {
    width: 190px;
    height: 24px;
    padding: 0 3px;
  }
}

.sele2 {
  /deep/ .el-input__inner {
    width: 110px;
    height: 24px;
    line-height: 24px;
    border: 1px solid #d2d7e6;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 14px;
    color: #818ea8;

    // color: #f0f;
  }

  /deep/ .el-input--suffix {
    width: 110px;
    height: 24px;
  }

  /deep/ .el-select {
    width: 110px;
    height: 24px;
    padding: 0 3px;
  }
}

/deep/ .el-input__icon {
  line-height: 24px;
}

.class-a {
  background: lightpink;
  // background: rgb(250, 20, 59);
  width: 100%;
}

.class-b {
  background: #fff;
}

.xin {
  // width: 98%;
  display: flex;
  // flex-direction: column;
  // align-items: center;
  justify-content: center;
  background: #f2f6fb;

  border: 2px solid #d2d7e6;
  // border-top: 0px;
  // padding: 14px;
}

// .tu2 {
//     border-bottom: 10px solid #ededed;
//     // border-top: 10px solid #ededed;
// }

// .tu1 {
//     // border-left: 20px solid #ededed;

//     width: 100%;
//     display: flex;
//     flex-wrap: wrap;
//     justify-content: center;
//     align-items: center;

//     p {
//         padding-bottom: 10px;
//         text-align: center;
//         font-family: "微软雅黑";
//         width: 90%;
//     }

//     .b {
//         padding-top: 10px;

//         width: 44%;
//         padding-left: 60px;
//         // border-bottom: 10px solid #ededed;
//         display: flex;
//         flex-direction: column;
//         align-items: center;
//         justify-content: center;
//     }

//     .b1 {
//         padding-top: 10px;
//         border-right: 10px solid #ededed;
//     }

//     .b2 {
//         padding-top: 10px;
//         // border-right: 10px solid #eee;
//     }
// }
</style>
